import React, { useEffect, useState } from 'react';
import { Loader } from 'react-feather';
import ManageTable from '../../Manage/ManageTable';
import PopupModal from '../../Manage/PopupModal';
import { Col, Row } from 'reactstrap';
import { NewsLetterStyle } from '../../../StyledComponents';
import TicketDescription from './TicketDescription';
import { IoCaretBackOutline } from 'react-icons/io5';

const ClosedTicketsView = () => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [modal, setModal] = useState(false);
  const handleModal = () => setModal(!modal);

  const [showForm, setShowForm] = useState(false);

  const handleAdd = () => {
      setShowForm(false);
  };

  const mockData = [
   
    {
      ticket_id: "#123456789",
      date: "30/04/2024",
      category: "Order issue",
      status: "In progress",
      ticket_status: "Closed",
      description: "I placed an order (#789012) last week, but I haven't received any confirmation email or shipping updates yet. Can you please provide an update on my order status?"
    },
    {
      ticket_id: "#123456789",
      date: "30/04/2024",
      category: "Order issue",
      status: "In progress",
      ticket_status: "Closed",
      description: "I placed an order (#789012) last week, but I haven't received any confirmation email or shipping updates yet. Can you please provide an update on my order status?"
    }
  ];

  useEffect(() => {
    // Simulate fetching data
    setTableData(mockData);
    setLoading(false);
  }, []);

  const [openName, setOpenName] = useState('');
  const [data, setData] = useState([]);

  const clickHandler = (data) => {
      setShowForm(true);
      setData(data)
  };

  const columns = [
    {
      name: "Ticket ID",
      cell: (row) => <span title={row.ticket_id} className="ellipsis">{row.ticket_id}</span>,
      selector: (row) => row.ticket_id,
      sortable: true,
    },
    {
      name: "Date",
      cell: (row) => <span title={row.date} className="ellipsis">{row.date}</span>,
      selector: (row) => row.date,
      sortable: true,
    },
    {
      name: "Category",
      cell: (row) => <span title={row.category} className="ellipsis">{row.category}</span>,
      selector: (row) => row.category,
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => <span title={row.status} className="ellipsis">{row.status}</span>,
      selector: (row) => row.status,
      sortable: true,
    },
    {
      name: "Ticket Status",
      cell: (row) => <span title={row.ticket_status} style={{ cursor: 'pointer', color: '#EC7426' }} className="ellipsis">{row.ticket_status}</span>,
      selector: (row) => row.ticket_status,
      sortable: true,
    },
    {
        name: "Description",
        cell: (row) => (
            <span
                title={row.description}
                className="ellipsis"
                style={{ cursor: 'pointer', }}
               
            >
                {row.description}
            </span>
        ),
        selector: (row) => row.description,
        sortable: true,
    },
    {
        name: "Action",
        cell: (row) => (
            <span
                title={'View'}
                className="ellipsis"
                style={{ cursor: 'pointer', }}
                onClick={() => clickHandler(row)}
            >
                {'View'}
            </span>
        ),
        selector: (row) => 'View',
        sortable: true,
    }
  ];

  return (
    <>
       {showForm ? (
                <>
                    <Row className='px-md-4 p-2'>
                        <Col xl='1' lg='1' md='1' sm='12' xs='12'><NewsLetterStyle style={{ fontSize: '18px', cursor: 'pointer' }} onClick={() => setShowForm(false)}> <IoCaretBackOutline /> Back</NewsLetterStyle></Col>
                        <Col xl='11' lg='11' md='11' sm='12' xs='12'>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                <NewsLetterStyle style={{ fontWeight: '700' }}>Ticket Description</NewsLetterStyle>
                            </div>
                            <TicketDescription data={data} showState={handleAdd} onCancel={() => setShowForm(false)} />
                        </Col>
                    </Row>
                </>
            ) : (
                <div>
                    {loading ? <Loader /> :
                        <ManageTable
                            name={'Closed Tickets'}
                            columns={columns}
                            setTableData={setTableData}
                            tableData={tableData}
                        />
                    }
                </div>
            )}

    </>
  );
};

export default ClosedTicketsView;
